// removed by extract-text-webpack-plugin
module.exports = {"change-box-left":"Fb9zIGE0BeVxpazF4nK5v_0","change-box-right":"_2nI8bMb6nnPHm0vwtg4rwa_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0fd1cd0f","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/config/node/netdevice/config/index.vue
// module id = VEZp
// module chunks = 75